export default __webpack_public_path__ + "static/media/0.c0a721aa.jpg";